// extracted by mini-css-extract-plugin
export default {"question":"Question_question__Fvvjg","number":"Question_number__xQmaN","mainWrapper":"Question_mainWrapper__Ia3Y+","addAnswerButton":"Question_addAnswerButton__ViCjT"};